export default "__VITE_ASSET__Deyv_FZR__"